import CONSTANTS from '../lib/constants';
import utils, { getLibraryPrefix } from '../utils';

let MODAL = {};
let lastFocus;
let targetElem;
let onCloseModal;

MODAL.init = function () {
  const isPreviewPage = window.location.pathname.includes('preview');
  const isEditPaymentPage = window.location.pathname.includes('editpayment');
  const cssClassPrefix =
    isPreviewPage || isEditPaymentPage
      ? CONSTANTS.UI_LIBRARY_PREFIX
      : CONSTANTS.STYLEGUIDE_VERSION;
  const modalElem = $(`.${cssClassPrefix}-modal`);
  modalElem.on('mousedown', function (evt) {
    targetElem = evt.target;
  });
  modalElem.on('click', function (evt) {
    if (evt.target === targetElem) {
      let modalClass = evt.target.getAttribute('class');
      modalClass = modalClass
        ? modalClass.split(' ').filter((s) => s === 'modal')
        : [];
      if (modalClass.length === 1) {
        const $modal = $(this);
        MODAL.disposeModal($modal);
      }
    }
  });
  $('.js-close-modal').click(closeModalHandler);
};

const closeModalHandler = function (e) {
  e.preventDefault();
  const cssClassPrefix = getLibraryPrefix($(this));
  let $modal = $(this).closest(`.${cssClassPrefix}-modal`);
  MODAL.disposeModal($modal);
};

const toggleAriaHidden = (shouldHide) => {
  const element = document.querySelector('.pp-GridContainer');
  if (!element) return;
  if (shouldHide) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
};

MODAL.disposeModal = function ($modal) {
  if (onCloseModal) {
    onCloseModal();
  }

  if (utils.isInternetExplorer()) {
    $modal.hide();
  } else {
    const cssClassPrefix = getLibraryPrefix($modal);
    $modal.removeClass(`${cssClassPrefix}-modal--open`);
  }
  $('body').removeClass('modal--open');
  toggleAriaHidden(false);
  if (
    $modal.hasClass('js-refresh-on-close') &&
    $modal.find('.info__box.commonFormError').length > 0
  ) {
    location.replace(location.href);
    return;
  }

  if ($modal.hasClass('js-non-persistent')) {
    MODAL.cleanUpModalForm($modal, true);
  } else if ($modal.hasClass('js-persistent')) {
    MODAL.resetModalForm($modal, true);
  }

  if (lastFocus) lastFocus.focus();

  let event = new CustomEvent('closeModal', { detail: $modal[0].classList });
  window.dispatchEvent(event);
};

MODAL.openModal = function ($modal, onOpen = null, onClose = null) {
  const cssClassPrefix = getLibraryPrefix($modal);
  if (utils.isInternetExplorer()) {
    $modal.show();
  } else {
    $modal.addClass(`${cssClassPrefix}-modal--open`);
  }
  $('body').addClass('modal--open');
  lastFocus = document.activeElement;
  toggleAriaHidden(true);
  trapTabbing($modal);
  $(
    `.${cssClassPrefix}-modal:visible .${cssClassPrefix}-modal__content`
  ).focus();

  // Callback functions
  if (onClose) {
    onCloseModal = onClose;
  }
  if (onOpen) {
    onOpen();
  }
};

MODAL.resetModalForm = function ($modal) {
  let $inputTypes = $(
    'input[type=text], input[type=email], input[type=password], input[type=tel]'
  );
  $modal.find($inputTypes).each(function () {
    $(this).val($(this).attr('data-initial-value'));
  });

  $modal.find('select').each(function () {
    let $select = $(this);
    $select.prop('selectedIndex', $select.attr('data-initial-value'));
  });
};

MODAL.cleanUpModalForm = function ($modal, triggerRadioButtons) {
  let $inputTypes = $(
    'input[type=text], input[type=email], input[type=password], input[type=tel]'
  ).not(':disabled');
  //  Reset form elements.
  $modal.find($inputTypes).val('');
  $modal.find('select').not(':disabled').prop('selectedIndex', 0);
  $modal.find('.form__field.ERROR').removeClass('ERROR');
  $modal.find('.form__field .ERROR').removeClass('ERROR');
  $modal.find('.error__icon').remove();
  $modal.find('span.error__message').text('');
  $modal.find('.info__box.ERROR').css('display', 'none');

  if (triggerRadioButtons) {
    //  GET each radio button group, select first element and fire change event.
    $modal.find('.js-radioGroup').each(function () {
      let $firstRadioBtn = $(this).find('input:radio:first');
      $firstRadioBtn.prop('checked', true).trigger('change');
    });
  }
};

MODAL.openThisModal = function ($modal, e) {
  e.preventDefault();
  e.stopPropagation();
  MODAL.openModal($modal);
};

const setLastFocus = (elem) => (lastFocus = elem);

// Function to trap the tab key inside the modal so it does not leak outside it
function trapTabbing($modal) {
  let inputs = $modal
    .find('select, input, textarea, button, a[href]')
    .filter(':visible')
    .not(':disabled');

  // Focus to first element in the container.
  inputs.first().focus();

  $modal.on('keydown', function (e) {
    if (e.which === 9) {
      let inputs = $modal
        .find('div[tabindex=0], select, input, textarea, button, a[href]')
        .filter(':visible')
        .not(':disabled');

      /* redirect last tab to first input*/
      if (!e.shiftKey) {
        if (inputs[inputs.length - 1] === e.target) {
          e.preventDefault();
          inputs.first().focus();
        }
      } else {
        /* redirect first shift+tab to last input*/
        if (inputs[0] === e.target) {
          e.preventDefault();
          inputs.last().focus();
        }
      }
    }
  });
}
export default MODAL;
export { setLastFocus, closeModalHandler };
